module.exports = __webpack_public_path__ + "static/scarecrow-bd5cea6e0b2a5da7f852740c797df51e.jpeg";